import { useLazyQuery } from '@apollo/client';
import { exportXlsModal } from 'motion-components';
import { useState } from 'react';
import { gqlGetPendingReceptionQuery } from '../graphql';
import { buildWhereFromFilterValues } from './filters';

export const exportColumns = (t) => [
  { fieldName: 'identificationDocument', fieldTitle: t('Αρ. Εντύπου Αναγνώρισης'), fieldType: 'TEXT' },
  { fieldName: 'dateCollected', fieldTitle: t('Ημερομηνία Συλλογής'), fieldType: 'DATETIME' },
  { fieldName: 'collectionPointName', fieldTitle: t('Σημείο Συλλογής'), fieldType: 'TEXT' },
  { fieldName: 'material.name', fieldTitle: t('Τύπος Αποβλήτου'), fieldType: 'TEXT' },
  { fieldName: 'netWeight', fieldTitle: t('Βάρος σε κιλά'), fieldType: 'FLOAT' },
  { fieldName: 'collectorCompanyName', fieldTitle: t('Συλλέκτης'), fieldType: 'TEXT' },
  { fieldName: 'vehPlateNumber', fieldTitle: t('Όχημα'), fieldType: 'TEXT' },
  { fieldName: 'driverFullName', fieldTitle: t('Οδηγός'), fieldType: 'TEXT' },
  {
    fieldName: 'wastereceptionpointCompanyName',
    fieldTitle: t('Εταιρεία Παραλαβής Αποβλήτων'),
    fieldType: 'TEXT',
  },
];

export function useGetQuery(): any {
  const [get, { loading }] = useLazyQuery(gqlGetPendingReceptionQuery, {
    onCompleted: transformData,
    fetchPolicy: 'no-cache',
  });
  const [result, setResult] = useState<any>([get, { loading, data: undefined }]);

  function transformData(data) {
    setResult([get, { loading, data }]);
  }

  return result;
}

export async function handleExport(client, queryState, t) {
  const filterVariables = {
    where: buildWhereFromFilterValues(queryState?.filterValues ?? {}),
  };
  await exportXlsModal({
    apolloClient: client,
    exportFileName: 'Εντυπα προς Παραλαβη',
    getLazyQuery: useGetQuery,
    columnsDef: exportColumns(t),
    filterVariables,
  });
}
